import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { isEmpty } from 'lodash';
import { Dialog, Grid } from "@material-ui/core";
import { SecondaryButton, ButtonSizeOptions, MaterialIcon, ButtonIcon } from '@loanbossinc/component-library';
import { PaddedDiv, StyledDialog, StyledInputText, StyledPrimaryButton, StyledTitle, FoundUserWrapper, FoundUserIcon, FoundUserIconInitials, FoundUserDetails, FoundName, FoundCompany, FoundEmail, FoundItemWrapper, DialogMessage, SingleCompanySelect, MultipleCompanySelect, CompanyItem, ConfirmText, ConfirmValue, SupportWrapper } from './styles';
import { searchUserEmail } from './dealSharing.store';
import { INITIAL_STEP, CONFIRM_CONTACT, CONFIRM_COMPANY, SELECT_COMPANY, CONTACT_SUPPORT, CONFIRM_SHARE, CANCEL_SHARE } from './enums';

class DealSharingModal extends Component {
  state = {
    step: INITIAL_STEP,
    companySharedToId: null,
    inputEmail: null,
    foundUser: null,
    foundUserCompany: null,
    foundUserCompanies: [],
    selectedCompany: { companyId: null }
  }

  componentDidUpdate(prevProps) {
    const { deal } = this.props;
    const { step } = this.state;

    if (deal.shared !== 0 && step !== CANCEL_SHARE)
      this.setState({ step: CANCEL_SHARE });
  }

  closeModal = () => {
    this.setState({ step: INITIAL_STEP });
    this.props.onClose();
  }

  onCancel = () => {
    this.setState({
      step: INITIAL_STEP,
      companySharedToId: null,
      inputEmail: null,
      foundUser: null,
      foundUserCompany: null,
      foundUserCompanies: [],
      selectedCompany: { companyId: null }
    });
    this.props.onClose();
  };

  emailSearchResult = () => {
    const { searchResult } = this.props;

    if (searchResult && searchResult.contact && !isEmpty(searchResult.contact)) {
      this.setState({
        step: CONFIRM_CONTACT,
        foundUser: searchResult.contact,
        foundUserCompany: null,
        foundUserCompanies: [],
        selectedCompany: { companyId: null }
      });
    } else if (searchResult && searchResult.companies && searchResult.companies.length === 1) {
      this.setState({
        step: CONFIRM_COMPANY,
        foundUser: null,
        foundUserCompany: searchResult.companies[ 0 ],
        foundUserCompanies: searchResult.companies,
        selectedCompany: searchResult.companies[ 0 ]
      });
    } else if (searchResult && searchResult.companies && searchResult.companies.length > 1) {
      this.setState({
        step: SELECT_COMPANY,
        foundUser: null,
        foundUserCompany: null,
        foundUserCompanies: searchResult.companies,
        selectedCompany: { companyId: null }
      });
    } else {
      this.setState({
        step: CONTACT_SUPPORT,
        foundUser: null,
        foundUserCompany: null,
        foundUserCompanies: [],
        selectedCompany: { companyId: null }
      });
    }
  };

  prevStep = () => {
    switch (this.state.step) {
      case INITIAL_STEP:
      case CANCEL_SHARE:
        this.onCancel();
        break;

      case CONFIRM_SHARE:
        this.setState({
          step: INITIAL_STEP
        });
        break;

      case CONFIRM_CONTACT:
      case CONFIRM_COMPANY:
      case SELECT_COMPANY:
      case CONTACT_SUPPORT:
      default:
        this.setState({
          step: INITIAL_STEP
        });
        break;
    }
  };

  nextStep = () => {
    const { deal, searchUserEmail, shareDeal, unShareDeal } = this.props;
    switch (this.state.step) {
      case INITIAL_STEP:
        searchUserEmail({ inputEmail: this.state.inputEmail, callback: this.emailSearchResult });
        break;

      case CONFIRM_CONTACT:
      case CONFIRM_COMPANY:
      case SELECT_COMPANY:
        this.setState({
          step: CONFIRM_SHARE
        });
        break;

      case CONFIRM_SHARE:
        if (this.state.selectedCompany.companyId) {
          shareDeal({ companySharedToId: this.state.selectedCompany.companyId, callback: this.onCancel });
        } else if (this.state.foundUser) {
          shareDeal({ companySharedToId: this.state.foundUser.companyId, callback: this.onCancel });
        }
        break;

      case CANCEL_SHARE:
        let dealId;
        let owningCompanyId;
        if (deal.shared === 1) {
          dealId = deal.id;
          owningCompanyId = deal.owningCompanyId;
        } else if (deal.shared === 2) {
          dealId = deal.secondaryShare[0].primary.id;
          owningCompanyId = deal.secondaryShare[0].primary.owningCompanyId;          
        }

        unShareDeal({dealId, owningCompanyId, callback: this.onCancel});
        break;

      case CONTACT_SUPPORT:
      default:
        this.onCancel();
        break;
    }
  };

  getButtonLabel = (buttonType) => {
    if (buttonType === 1) {
      switch (this.state.step) {
        case INITIAL_STEP:
          return 'Continue';
        case CONFIRM_CONTACT:
        case CONFIRM_COMPANY:
        case SELECT_COMPANY:
          return 'Yes';
        case CONTACT_SUPPORT:
          return 'Okay';
        case CONFIRM_SHARE:
          return 'Share Deal';
        case CANCEL_SHARE:
          return 'Yes, stop sharing';
        default: 
          return 'Continue';
      }
    } else if (buttonType === 2) {
      switch (this.state.step) {
        case INITIAL_STEP:
          return 'Cancel';
        case CANCEL_SHARE:
          return 'No, keep sharing';
        default: 
          return 'Back';
      }
    }
  };

  selectCompany = (company) => {
    if(this.state.selectedCompany.companyId === company.companyId){
      this.setState({ selectedCompany: { companyId: null } });
    } else {
      this.setState({ selectedCompany: company });
    }
  }

  getSharedCompany = () => {
    const { deal } = this.props;
    if(deal.shared === 0)
      return "Not Shared";
    else if(deal.shared === 1)
      return deal.primaryShare[0].secondary.owningCompany.name;
    else if(deal.shared === 2)
      return deal.secondaryShare[0].primary.owningCompany.name;
    else
      return "Undetermined";
  }

  render() {
    const modalTitle = "Deal Sharing";
    const { deal, isOpen } = this.props;
    const { foundUser } = this.state;

    let buttonLabelPrimary = this.getButtonLabel(1);
    const buttonLabelSecondary = this.getButtonLabel(2);
    const isDisabled = (this.state.step === SELECT_COMPANY && !this.state.selectedCompany.companyId) || false;

    return (
      <StyledDialog>
        <Dialog
          open={isOpen}
          onClose={this.closeModal}
          fullWidth
          maxWidth="sm"
          id="dealModel">
          <Grid
            container
            direction="row"
            alignItems="center"
            justify="space-between">
            <StyledTitle id="dealModelHeader">
              <div>
                {modalTitle} <MaterialIcon style={{ marginLeft: '16px' }} iconName={"share"} />
              </div>
              <div>
                <ButtonIcon style={{ marginRight: '16px' }} hasBorder={false} iconName="highlight_off" onClick={this.onCancel} />
              </div>
            </StyledTitle>
          </Grid>
          <PaddedDiv>
            {this.state.step === INITIAL_STEP &&
              <FoundItemWrapper>
                <DialogMessage>
                  <div>Who would you like to share this deal with?</div>
                  <div>Enter their email below to continue.</div>
                </DialogMessage>
                <div>
                  <StyledInputText
                    name="email"
                    label="Email"
                    defaultValue={this.state.inputEmail}
                    onChange={(event) => this.setState({ inputEmail: event?.target?.value })} />
                </div>
              </FoundItemWrapper>}

            {this.state.step === CONFIRM_CONTACT &&
              <FoundItemWrapper>
                <DialogMessage>
                  <div>We found someone with the email address:</div>
                  <div>{this.state.inputEmail}</div>
                  <div>Would you like to share this deal with them?</div>
                </DialogMessage>
                <FoundUserWrapper>
                  <FoundUserIcon>
                    <FoundUserIconInitials>{foundUser.initials}</FoundUserIconInitials>
                  </FoundUserIcon>
                  <FoundUserDetails>
                    <FoundName>{foundUser.fullName}</FoundName>
                    <FoundCompany>{foundUser.company}</FoundCompany>
                    <FoundEmail>{foundUser.email}</FoundEmail>
                  </FoundUserDetails>
                </FoundUserWrapper>
              </FoundItemWrapper>
            }

            {this.state.step === SELECT_COMPANY &&
              <FoundItemWrapper>
                <DialogMessage>
                  <div>We couldn’t find anyone with the email address:</div>
                  <div>{this.state.inputEmail}</div>
                  <div>However, it looks like their company is part of LoanBoss.</div>
                  <div>Please select the company you would like to share this deal with.</div>
                </DialogMessage>
                <MultipleCompanySelect>{this.state.foundUserCompanies.map(x => {
                  return (
                    <CompanyItem
                      selectedCompanyId={this.state.selectedCompany.companyId}
                      companyId={x.companyId}
                      onClick={() => this.selectCompany(x)}>
                      {x.companyName}
                    </CompanyItem>)
                })}
                </MultipleCompanySelect>
              </FoundItemWrapper>
            }

            {this.state.step === CONFIRM_COMPANY &&
              <FoundItemWrapper>
                <DialogMessage>
                  <div>We couldn’t find anyone with the email address:</div>
                  <div>{this.state.inputEmail}</div>
                  <div>However, it looks like their company is part of LoanBoss.</div>
                  <div>Would you like to share this deal with them?</div>
                </DialogMessage>
                <SingleCompanySelect>{this.state.foundUserCompanies.map(x => {
                  return (
                    <CompanyItem
                      selectedCompanyId={this.state.selectedCompany.companyId}
                      companyId={x.companyId}>
                      {x.companyName}
                    </CompanyItem>)
                })}
                </SingleCompanySelect>
              </FoundItemWrapper>
            }

            {this.state.step === CONFIRM_SHARE &&
              <FoundItemWrapper>
                <DialogMessage>Confirm Sharing</DialogMessage>
                <ConfirmText>Clicking continue below will share Deal</ConfirmText>
                <ConfirmValue>{deal.name}</ConfirmValue>
                <ConfirmText>with</ConfirmText>
                <ConfirmValue>{this.state.foundUser ? this.state.foundUser.company : this.state.selectedCompany ? this.state.selectedCompany.companyName : ""}</ConfirmValue>
              </FoundItemWrapper>
            }

            {this.state.step === CONTACT_SUPPORT &&
              <FoundItemWrapper>
                <DialogMessage>
                  <div>We couldn’t find anyone with the email address:</div>
                  <div>{this.state.inputEmail}</div>
                  <div>Their company doesn’t appear to be part of LoanBoss.</div>
                  <div>Please reach out to LoanBoss support if you feel you’ve received this message in error.</div>
                </DialogMessage>
                <SupportWrapper>
                  <a href='mailto:support@loanboss.com'>support@loanboss.com</a>
                </SupportWrapper>
              </FoundItemWrapper>
            }
            {this.state.step === CANCEL_SHARE &&
              <FoundItemWrapper>
                <DialogMessage>
                  <div>This deal is currently shared and synced with</div>
                  <div>{this.getSharedCompany()}</div>
                  <div>Would you like to stop sharing deal updates?</div>
                </DialogMessage>
              </FoundItemWrapper>
            }
            <Grid container direction="row" justify="flex-end">
              <SecondaryButton label={buttonLabelSecondary} size={ButtonSizeOptions.smFluid} onClick={this.prevStep} style={{ marginTop: '16px' }} />
              <StyledPrimaryButton disabled={isDisabled} label={buttonLabelPrimary} size={ButtonSizeOptions.smFluid} onClick={this.nextStep} style={{ marginTop: '16px' }} />
            </Grid>

          </PaddedDiv>
        </Dialog>
      </StyledDialog>
    );
  }
}

const mapStateToProps = ({ dealSharing, authentication }) => {
  return ({
    ...dealSharing
    , authentication
  })
};

export default compose(
  connect(mapStateToProps, {
    searchUserEmail
  })
)(DealSharingModal);
